@if (true) {
    <div class="modal-body">
        <form [formGroup]="form"  (submit)="submitForm(); ">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="inputState">Sharing User</label>
                                <ng-select [items]="userList" [clearable]="false" formControlName="drUser" [multiple]="true"  bindLabel="USERNAME" [selectableGroup]="true" [closeOnSelect]="true" bindValue="ID" [(ngModel)]="selectedUser">
                                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                        {{item.USERNAME}}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="inputState">Remarks</label>
                                <input type="text" class="form-control" formControlName="Remarks" placeholder="Remarks"
                                    required="required" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center mt-3">
                <button class="btn btn-primary submit-btn small" type="submit">
                    {{buttonName}}
                </button>
            </div>
        </form>
    </div>
}@else{
    <!-- <form [formGroup]="form" class="modal-body  col-sm-12 form-group" (submit)="submitForm(); ">
       
        <div class="col-sm-2">
            Sharing User
        </div>
    
        <div class="col-sm-6">
    
                <ng-select [items]="userList" [clearable]="false" formControlName="drUser" [multiple]="true"  bindLabel="USERNAME" [selectableGroup]="true" [closeOnSelect]="true" bindValue="ID" [(ngModel)]="selectedUser">
                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        {{item.USERNAME}}
                    </ng-template>
                </ng-select>
        </div>
        <br><br><br>
        <div class="col-sm-2">
           Remarks
        </div>
    
        <div class="col-sm-6">
            <textarea type="text" formControlName="drRemarks"  class="form-control TextareafullSize"></textarea>
        </div>
    
       
    
        <div>
            <div class="col-sm-12">&nbsp;</div>
            <div class="form-group">
              
                <div>
                    <div class="col-sm-2">&nbsp;</div>
                    <input class="btn btn-primary col-sm-2" type="submit" value={{this.buttonName}}>
                    <div class="col-sm-1">&nbsp;</div>
                    <div class="col-sm-1" style="display: none;">&nbsp;</div>
                    <div class="col-sm-2">&nbsp;</div>
                </div>
            </div>
        </div>
       
        <div class="jumbotron p-4">
            <div class="container text-center col-sm-3 alertCss">
                <app-alert></app-alert>
                <router-outlet></router-outlet>
            </div>
        </div>
    </form> -->
}